import { render, staticRenderFns } from "./currencyHold.vue?vue&type=template&id=4d2ce972"
import script from "./currencyHold.vue?vue&type=script&lang=js"
export * from "./currencyHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports